import { render, staticRenderFns } from "./ItemLists.vue?vue&type=template&id=716f1fc8&scoped=true&"
import script from "./ItemLists.vue?vue&type=script&lang=js&"
export * from "./ItemLists.vue?vue&type=script&lang=js&"
import style0 from "./ItemLists.vue?vue&type=style&index=0&id=716f1fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f1fc8",
  null
  
)

export default component.exports